import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';

import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {Page} from '../index';

@Injectable({   providedIn: 'root' })
export class PageDaoService extends DaoGeneric<Page> {
  private url = `${environment.baseUrl}/api_bdc/pages/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

}
